import type { InvestigationCollectionItem } from '@nuxt/content'

export default async function () {
  return useAsyncData<InvestigationCollectionItem[]>(
    'investigation-articles',
    async () => {
      return queryCollection('investigation')
        .where('published', '=', true)
        .order('date', 'DESC')
        .all()
    },
    {
      default(): InvestigationCollectionItem[] {
        return []
      },
    },
  )
}
